import { render, staticRenderFns } from "./singleImageUpload.vue?vue&type=template&id=3ae35522&scoped=true&"
import script from "./singleImageUpload.vue?vue&type=script&lang=js&"
export * from "./singleImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./singleImageUpload.vue?vue&type=style&index=0&id=3ae35522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae35522",
  null
  
)

export default component.exports